import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { Trash2 } from 'lucide-react';

type ContentImage = { src: string; alt?: string };

function editorPreviewSource(source: string) {
  return source.replace(/^\/api\/public\/media\/([^?]+)(.*)$/, '/api/media/$1/file$2');
}

/** Editor-only controls for a two-column image block. */
export function ImageRowView({ deleteNode, node }: NodeViewProps) {
  const images = node.attrs.images as ContentImage[];

  return (
    <NodeViewWrapper className="image-row group relative my-4 grid grid-cols-2 gap-4" data-type="image-row">
      {images.map(image => (
        <img
          key={image.src}
          src={editorPreviewSource(image.src)}
          alt={image.alt ?? ''}
          className="m-0 h-full w-full rounded-md object-cover"
        />
      ))}
      <button
        type="button"
        contentEditable={false}
        title="Beeldenrij verwijderen"
        aria-label="Beeldenrij verwijderen"
        className="absolute right-2 top-2 inline-flex size-8 items-center justify-center rounded-md bg-background/90 text-muted-foreground opacity-0 shadow-sm transition-all hover:bg-destructive hover:text-destructive-foreground focus:opacity-100 group-hover:opacity-100"
        onMouseDown={event => event.preventDefault()}
        onClick={deleteNode}
      >
        <Trash2 className="size-4" />
      </button>
    </NodeViewWrapper>
  );
}
